import { useQuery } from "@tanstack/react-query";
import {
	type GetReturnedRollsParams,
	getReturnedRollsData,
} from "../repositories/ReturnedRollsRepository";

type UseReturnedRollsParams = Omit<GetReturnedRollsParams, "signal">;

export const useReturnedRolls = (params: UseReturnedRollsParams) => {
	return useQuery({
		queryKey: ["returnedRolls", params],
		queryFn: ({ signal }) => getReturnedRollsData({ ...params, signal }),
		enabled: !!params.start && !!params.end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
